import React from 'react';
import { compose } from 'redux';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import {
  withMobileContext,
  WithMobileContextProps,
} from '@wix/da-react-context/pkg/MobileContext';
import { ShopItemType } from '../../../../../types/shop';
import ShopGrid from '../ShopGrid';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import ShopCommissionsControls from './ShopCommissionsControls';
import UploadMore from '../_partials/UploadMore';
import s from '../ShopSection.scss';

export interface Props {
  className?: string;
  isOwner: boolean;
  isOpenForCommissions: boolean;
  onCreate: () => void;
}

const enhance = compose(withMobileContext, withSectionFetchSpinner);
export class ShopCommissions extends React.Component<
  Props & WithMobileContextProps
> {
  render() {
    const { className, isOpenForCommissions, isOwner, isMobile, onCreate } =
      this.props;

    return (
      <div className={s['section-with-no-header']}>
        <ShopCommissionsControls />
        {(isOpenForCommissions || (isOwner && !isMobile)) && (
          <ShopGrid
            className={className}
            itemType={ShopItemType.COMMISSIONS}
            emptyState={false}
            uploadMore={
              <UploadMore
                itemType={ShopItemType.COMMISSIONS}
                onCreate={onCreate}
                biData={BiData<DefaultBiEvent>({
                  evid: 2,
                  click_info: 'create_commission',
                  sectionname: 'commission',
                })}
              />
            }
          />
        )}
      </div>
    );
  }
}

export default enhance(ShopCommissions) as React.ComponentType<Props>;
